class ContactContentForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
  }

  connectedCallback() {
    const submitButton = this.form.querySelector("button:not(.success-close-btn)");
    if (submitButton) {
      submitButton.addEventListener("click", (event) => this.onSubmit(event));
    }

    const inputs = this.form.querySelectorAll('input:not([type="hidden"]), textarea');

    inputs.forEach((input) => {
      input.addEventListener("input", (event) => this.checkInputValidation(event));
      input.addEventListener("blur", (event) => this.checkInputValidation(event));
    });

    const successCloseBtn = this.querySelector(".success-close-btn");
    if (successCloseBtn) {
      successCloseBtn.addEventListener("click", () => this.hideSuccessOverlay());
    }
  }

  hideSuccessOverlay() {
    const pagePath = this.getAttribute("data-page-path");
    const targetPath = pagePath && pagePath !== "" ? pagePath : new URL(window.location.href).pathname;
    window.location.href = targetPath;
  }

  checkInputValidation(event) {
    const input = event.target;
    const validity = input.validity;
    const submitButton = this.form.querySelector("button:not(.success-close-btn)");

    if (!validity.valid) input.parentElement.classList.add("error");
    if (validity.valid) input.parentElement.classList.remove("error");
    if (submitButton) submitButton.disabled = false;
  }

  onSubmit(event) {
    const submitButton = this.form.querySelector("button:not(.success-close-btn)");
    submitButton.disabled = true;

    const formInputs = this.form.querySelectorAll("input, textarea");
    let allValid = true;

    formInputs.forEach((input) => {
      if (!input.validity.valid) {
        allValid = false;
        input.parentElement.classList.add("error");
      } else {
        input.parentElement.classList.remove("error");
      }
    });

    if (allValid) {
      if (!this.form.checkValidity()) {
        this.form.reportValidity();
        submitButton.disabled = false;
        return;
      }
      this.form.submit();
    }
  }
}

customElements.define("contact-content-form", ContactContentForm);
